import { render, staticRenderFns } from "./RoleItemLista.vue?vue&type=template&id=d7c37faa"
import script from "./RoleItemLista.vue?vue&type=script&lang=js"
export * from "./RoleItemLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports